import { IPrice } from '@vacationtracker/shared/data/stripe/prices'

export function calculateTotalPrice(price: IPrice, quantity: number): number {
  if (price.tiers && price.tiers.length > 0) {
    const tier = price.tiers.find(t => t.up_to === 'inf' || quantity <= (t.up_to as number))
    if (tier) {
      if (tier.flat_amount !== undefined) return tier.flat_amount / 100
      if (tier.unit_amount !== undefined) return (tier.unit_amount * quantity) / 100
    }
  }
  return price.pricePerUser * quantity
}
